import { render, staticRenderFns } from "./ServiceablesCard.vue?vue&type=template&id=30b42918&scoped=true"
import script from "./ServiceablesCard.vue?vue&type=script&lang=js"
export * from "./ServiceablesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b42918",
  null
  
)

export default component.exports